import { ReleaseEnv } from '@/types/releaseEnv';

import useReleaseEnv from './useReleaseEnv';

export default function useIsReadOnly() {
  const releaseEnv = useReleaseEnv();

  return releaseEnv === ReleaseEnv.Production;
}
